import { render, staticRenderFns } from "./HelpCenterManagement.vue?vue&type=template&id=68783f78&scoped=true&"
import script from "./HelpCenterManagement.vue?vue&type=script&lang=js&"
export * from "./HelpCenterManagement.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterManagement.vue?vue&type=style&index=0&id=68783f78&lang=less&scoped=true&"
import style1 from "./HelpCenterManagement.vue?vue&type=style&index=1&id=68783f78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68783f78",
  null
  
)

export default component.exports